import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Our_Presence from "./our-presence/Our_Presence";
import Free_Consultation from "./free-consultation/Free_Consultation";
import Consultation_Banner from "./consultation-banner/Consultation_Banner";
import What_Customer_Say from "./what-customer-say/What_Customer_Say";
import Category_slider from "./category_slider/Category_slider";
import How_we_work from "./how_we_work/How_we_work";
import Our_solutions from "./our_solutions/Our_solutions";
import About_us from "./about_us/About_us";
import Become_a_dealer from "./become_a_dealer/Become_a_dealer";
import Vision_Mission_Value from "../about-us/vision-mission-value/Vision_Mission_Value";
import Our_client_partners from "./our_client_partners/Our_client_partners";
import Best_seller from "./best_seller/Best_seller";
import Explore_our_gallery from "./explore_our_gallery/Explore_our_gallery";
import { Helmet } from "react-helmet-async";

function Home() {
  return (
    <>
      <Helmet>
        <title>
          AYZAIR | Industrial Air Cooler, HVLS Fan & Exhaust Fan Manufacturer
        </title>
        <meta
          name="title"
          content="AYZAIR | Industrial Air Cooler, HVLS Fan & Exhaust Fan Manufacturer"
        />
        <meta
          name="description"
          content="AYZAIR is a leading manufacturer & supplier of Duct Air Coolers, Industrial Air Coolers, Commercial Air Coolers, Portable Air Coolers, Industrial Exhaust Fans, Hammer Exhaust Fans, HVLS Fans, Duct Inline Fans, Mix Flow Fans, Inline Jet Fans & High Volume Circulation Fans across India. Get a Free Quote Today!"
        />
        <link rel="canonical" href={"https://www.ayzair.com/"} />
      </Helmet>

      <Banner />

      <Best_seller />
      <How_we_work />
      <Our_solutions />
      <About_us />
      <Become_a_dealer />
      <Vision_Mission_Value />
      <Our_client_partners />
      <What_Customer_Say />
      <Explore_our_gallery />
      <Our_Presence />
    </>
  );
}

export default Home;
